import React from "react";
import Link from "next/link";
import Router from "next/router";
import { useTranslation } from "next-i18next";

import BoardList from "@sellernote/ui/src/sds-v1/components/board/BoardList";
import BoardPageTitle from "@sellernote/ui/src/sds-v1/components/board/BoardPageTitle";
import TextButton from "@sellernote/ui/src/sds-v1/components/button/TextButton";

import CommonStyled from "../index.styles";

export default function BoardSection({
  title,
  listData,
  moreHref,
}: {
  title: string;
  listData: [];
  moreHref: string;
}) {
  const { t } = useTranslation(["support-new"]);

  return (
    <CommonStyled.boardSection>
      <CommonStyled.boardHeader>
        <BoardPageTitle titleStyle="section">{title}</BoardPageTitle>

        <TextButton
          theme="withIcon"
          size="14px"
          label={t("support-new:공통_더보기")}
          icon="arrowRight"
          handleClick={() => {
            Router.push({
              pathname: moreHref,
            });
          }}
        />
      </CommonStyled.boardHeader>

      <BoardList
        listData={listData}
        boardItemHref={moreHref}
        LinkComponent={Link}
      />
    </CommonStyled.boardSection>
  );
}
